export default function sumArray(array) {
  function getSum(total, num) {
    return total + num
  }
  return array.reduce(getSum)
}


// WEBPACK FOOTER //
// ./src/helpers/sumArray.js